export const FullPagePadding = 32;
export const TELEPOINTER_ID = 'ai-streaming-telepointer';
